import plur from 'plur'
import {memo, Suspense} from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay'
import {useLocation} from 'react-router-dom'

import type {ChangeId} from '../../../../types'
import {stringifyId} from '../../../../types'
import {queryToObject} from '../../../../utils/queryParams'

import type {ChangeStatusQuery} from './__generated__/ChangeStatusQuery.graphql'

const query = graphql`
  query ChangeStatusQuery($changeLocator: String!) {
    change(changeLocator: $changeLocator) {
      status {
        finishedBuilds
        runningBuilds
        pendingBuildTypes
      }
    }
  }
`

type Props = {
  changeId: ChangeId
}

function ChangeStatus({changeId}: Props) {
  const location = useLocation()
  const personal = queryToObject(location.search)?.personal === 'true'
  const changeLocator = `id:${stringifyId(changeId)},personal:${personal}`

  const {change} = useLazyLoadQuery<ChangeStatusQuery>(query, {changeLocator})
  const {status} = change ?? {}
  const finishedBuilds = status?.finishedBuilds ?? 0
  const runningBuilds = status?.runningBuilds ?? 0
  const pendingBuildTypes = status?.pendingBuildTypes ?? 0

  if (finishedBuilds > 0 || runningBuilds > 0) {
    return `${finishedBuilds} finished, ${runningBuilds} running, ${pendingBuildTypes} pending ${plur(
      'build',
      pendingBuildTypes,
    )}`
  } else {
    return `No builds with this change have started yet (${pendingBuildTypes} pending)`
  }
}

export default memo(function ChangeStatusContainer(props: Props) {
  return (
    <div>
      <Suspense fallback={'Loading...'}>
        <ChangeStatus {...props} />
      </Suspense>
    </div>
  )
})
